import { render, staticRenderFns } from "./DownloadPngOptions.vue?vue&type=template&id=0b7a009a&scoped=true"
import script from "./DownloadPngOptions.vue?vue&type=script&lang=js"
export * from "./DownloadPngOptions.vue?vue&type=script&lang=js"
import style0 from "./DownloadPngOptions.vue?vue&type=style&index=0&id=0b7a009a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a009a",
  null
  
)

export default component.exports